import types from 'actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import Immutable from 'seamless-immutable'
import {get} from 'lodash'

const open = (state = false, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return true
        case types.QUOTING_QUOTE_HIDE_ITEM_DRAWER:
            return false
        case types.QUOTING_QUOTE_ADD_ORDER_ITEM:
            return state && !action.closeDrawer
        case types.QUOTING_LOAD_QUOTE_ATTEMPT:
            return false
        default:
            return state
    }
}

const orderItem = (state = null, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return action.orderItem
        case types.QUOTING_QUOTE_HIDE_ITEM_DRAWER:
            return null
        default:
            return state
    }
}

const part = (state = null, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return action.part || get(action, 'orderItem.part', null)
        case types.QUOTING_QUOTE_HIDE_ITEM_DRAWER:
            return null
        default:
            return state
    }
}

const index = (state = null, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return action.index
        case types.QUOTING_QUOTE_HIDE_ITEM_DRAWER:
            return null
        default:
            return state
    }
}

const defaults = (state = null, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return action.defaults
        default:
            return state
    }
}

const template = (state = null, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return action.template
        default:
            return state
    }
}

const createNewSubItem = (item, state) => ({
    ...item,
    order: state.length + 1,
})

const subItemsLoaded = (state = false, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_SHOW_ITEM_DRAWER:
            return false

        case types.PIVOT_TABLE_UPDATE_DATA:
        case types.PIVOT_TABLE_LOAD_SUCCESS:
        case types.PIVOT_TABLE_LOAD_FAILURE:
            return action.key === subItemPivotTableKey
                ? true
                : state

        default:
            return state
    }
}

// Distinguishes the pricing write-back (updateSubItemPricing) from a user's own sub-item
// mutation, so the drawer only recalculates for the latter and cannot re-trigger itself.
export const pricingApplied = (state = false, action) => {
    if (action.key !== subItemPivotTableKey)
        return action.type === types.QUOTING_QUOTE_SHOW_ITEM_DRAWER ? false : state

    switch (action.type) {
        case types.PIVOT_TABLE_SET_ENTITIES:
            return !!action.fromPricing

        case types.PIVOT_TABLE_ADD_ENTITY:
        case types.PIVOT_TABLE_ADD_ENTITY_AT_INDEX:
        case types.PIVOT_TABLE_COPY_ENTITY:
        case types.PIVOT_TABLE_DELETE_ENTITY:
        case types.PIVOT_TABLE_EDIT_ENTITY:
        case types.PIVOT_TABLE_REORDER_ENTITY:
        case types.PIVOT_TABLE_UPDATE_DATA:
        case types.QUOTING_PRICE_LIST_ADD_ENTITIES:
            return false

        default:
            return state
    }
}

export const isSaving = (state = false, action) => {
    switch (action.type) {
        case types.QUOTING_QUOTE_ADD_ORDER_ITEM:
        case types.QUOTING_QUOTE_EDIT_ORDER_ITEM:
            return true

        // SAVE_RECEIVED comes over the websocket and never lands if it dropped,
        // so the watchdog in quotingSaga releases this if it does not arrive.
        case types.QUOTING_QUOTE_SAVE_FAILURE:
        case types.QUOTING_QUOTE_SAVE_RECEIVED:
        case types.QUOTING_QUOTE_SAVE_CONFIRMATION_TIMEOUT:
        case types.QUOTING_LOAD_QUOTE_ATTEMPT:
            return false
        default:
            return state
    }
}

export const subItemPivotTableKey = 'quotingContext.selected.itemDrawer.subItems'

export default combineReducers({
    open,
    orderItem,
    part,
    index,
    defaults,
    template,
    subItems: createPivotTableReducer({
        key: subItemPivotTableKey,
        defaultSortColumn: Immutable('order'),
        defaultSortDirection: Immutable('asc'),
        pageSize: 50,
        defaultGridStretch: false,
        defaultAreAllRowsSelected: false,
        defaultCanSelectRows: false,
        retainEdits: false,
        onNewEntity: createNewSubItem,
    }),
    subItemsLoaded,
    pricingApplied,
    isSaving,
})
